export default __webpack_public_path__ + "media/circle/miterna-0219c4a7.svg";